import React from 'react';
import { withRouter } from 'react-router';
import { QRCode } from 'react-qrcode-logo';
// import ModernBg1 from './ModernBg1';
// import Responsive from './Responsive';
import { translate } from '../../../utils/useful';
import { siteConfig } from '../../../variables/config';
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';


class InquirySuccess extends React.Component {

    state = {
        link: ''
    }

    componentDidMount() {
        let link = this.state.link
        console.log('this.props.baseurlaa', this.props)
        let baseUrl = [...this.props.baseUrl]
        // link = siteConfig.rootDomain + baseUrl[0] + '/' + baseUrl[1] + '/quiz'
        link = 'http://localhost:3007/' + baseUrl[0] + '/' + baseUrl[1] + '/quiz/' + this.props.record._id

        // if (Array.isArray(this.props.windowData.path)) {
        //     let path = this.props.windowData.path
        //     path.forEach(el => {
        //         if (el == path[0]) {
        //             link = link + el
        //         }
        //         else if (el == path[path.length - 1]) {
        //             return
        //         }
        //         else {
        //             link = link + "/" + el
        //         }
        //     });
        //     // if(this.props.editForm){
        //     link = link + '/' + this.props.record._id
        //     // }
        //     // link = siteConfig.rootDomain + link
        //     link = 'http://localhost:3007/' + link
        // }
        this.setState({ link })
        // console.log('this.props.dataaa', this.props)

        // console.log('this.props.data-inquiry', this.props.initData)
        if (this.props.setHeader) {
            if (this.props.editForm) {
                this.props.setHeader({
                    'toolbar': null,
                    'showToolbar': false,
                    topHeaderComponent: this.topHeaderComponent,
                    title: '{{lang}}Edit Inqueryaa',
                    // headerIdentityComponent: this.headerIdentityComponent,
                    // backAction: () => this.props.changePage(this.props.collectionId)
                })
            }
            else {
                this.props.setHeader({
                    'toolbar': true,
                    'showToolbar': false,
                    topHeaderComponent: this.topHeaderComponent,
                    title: '{{lang}}New Inqueryaa',
                    // headerIdentityComponent: this.headerIdentityComponent,
                    // backAction: () => this.props.changePage(this.props.collectionId)
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                {/* <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextStage}
                    title='{{lang}}Next'
                    icon='/assets/icons/arrow-right-white.svg'
                    // icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                /> */}
            </div>
        )
    }

    visitQuiz = () => {
        let newLink = []
        // let baseUrl = [...this.props.baseUrl]
        // newLink = baseUrl.splice(2)
        // let baseUrl = this.props.baseUrl
        console.log('newwwwwwwwwwwwww', this.props)

        newLink.push('quiz')
        newLink.push(this.props.record._id)
        console.log('newwwwwwwwwwwwww', newLink)
        this.props.setData2('newInquiry', false, 'CollectionView')
        this.props.setData2('editInquiry', false, 'CollectionView')
        // if (Array.isArray(this.props.windowData.path)) {
        //     let path = this.props.windowData.path
        //     path.forEach(el => {
        //         if (el == path[0] || el == path[1]) {
        //             return
        //         }
        //         else if (el == path[path.length - 1]) {
        //             return
        //         }
        //         else {
        //             link.push(el)
        //             // link = link + "/" + el
        //         }
        //     });
        //     // if(this.props.editForm){
        //     link.push(this.props.record._id)
        //     // }
        //     // link = siteConfig.rootDomain + link
        //     // link = 'http://localhost:3007/' + link
        // }

        // console.log('linnnnnnnnnnnk', this.props.baseUrl)
        console.log('linnnnnnnnnnnk', newLink)

        this.props.changeWindowLink(newLink)
        // if (this.props.editForm) {
        //     this.props.changeReportPage('details')
        // }
    }

    render() {
        return (
            <div className="w-100 h-100" style={{ backgroundColor: '#f6f6f6' }}>
                <div className='h-100 w-100 flexc flex-column p-3'>
                    <div className='w-100 flexcc'>
                        <div className="flexc flex-column br-15 w-100 p-4" style={{ maxWidth: 800, transition: 'all 0.5s', backgroundColor: '#ffffff', }}>
                            <div className="w-100 flexc flex-column" style={{ maxWidth: 500, }}>
                                <QRCode onClick={() => this.visitQuiz()} quietZone={0} value={siteConfig.rootDomain + this.props.data.username} size="120" title={siteConfig.rootDomain + this.props.data.username} logoImage={'/assets/icons/applets/inquiry.png'} removeQrCodeBehindLogo={true} logoWidth={20} qrStyle={'dots'} eyeRadius={[[10, 10, 0, 10], [10, 10, 10, 0], [10, 0, 10, 10],]} eyeColor={'#303030'} enableCORS={true} ecLevel="Q" />
                                <h1 className="text-big mt-2">{this.props.language == 'fa' ? (translate('Quiz') + ' ' + this.props?.data?.values?.title) : translate('Quiz') + " " + this.props?.data?.values?.title}</h1>
                                <h2 className="text-semibig mb-2  mt-0">{this.props.editForm ? translate('ca.Edited Successfully') : translate('Created Successfully')}</h2>
                                <p className="mb-4 text-small text-center" style={{ maxWidth: 350 }}>{this.props.editForm ? translate('The quiz edited successfully. now you can have access to this quiz using the following address') : translate('The quiz created successfully. now you can have access to this quiz using the following address')}:</p>
                                <div className='py-2 px-3 mb-4 flexc' style={{ backgroundColor: '#f2f6f8', borderRadius: 10, border: '1px solid #f0f0f0' }}>
                                    {/* <button onClick={() => this.visitQuiz()} ><p className=" text-small text-center text-semibold" style={{ color: '#6764FE' }}>{String(this.state.link).length > 35 ? this.state.link.substring(0, 35) + '...' : this.state.link}</p></button> */}
                                    <button onClick={() => this.visitQuiz()} ><p className=" text-small text-center text-semibold" style={{ color: '#6764FE' }}>{this.state.link}</p></button>
                                    <img className='mld-4' src={'/assets/icons/useful/duplicate.svg'} width="20px" style={{ opacity: 0.3 }} />
                                </div>
                                <div className='flexc'>
                                    <button onClick={() => this.visitQuiz()} className='px-1 py-1  flexcc br-30' style={{ background: 'linear-gradient(90deg, #6E9318, #96C723)', color: '#fff' }}>
                                        <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Visit Quiz")}</p>
                                        <div className='flexcc mld-3 p-1 br-50' style={{ backgroundColor: 'rgba(225, 225, 225, 0.3)', }}>
                                            <img className='' src='/assets/icons/eye-white.svg' height={18} />
                                        </div>
                                    </button>
                                    <button onClick={() => this.visitQuiz()} className='p-1 mx-2 flexcc br-50' style={{ background: 'linear-gradient(90deg, #6E9318, #96C723)', color: '#fff' }}>
                                        <img className='flexcc' src='/assets/icons/share-white.svg' height={22} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(InquirySuccess)